import { describeFields, FieldWidget } from '../common/fields';
import { LeadSchema } from './schemas';

export const LEAD_FIELDS = describeFields(LeadSchema, {
  type: {},
  leadId: {},
  creationDatetime: { widget: FieldWidget.DateTime },
  firstName: {},
  lastName: {},
  school: {},
  schoolId: {},
  schoolLabel: {},
  schoolShortLabel: {},
  gradYear: { widget: FieldWidget.Number },
  email: {},
  phoneNumber: {},
  birthday: { widget: FieldWidget.Date },
  parentFirstName: {},
  parentLastName: {},
  parentEmail: {},
  parentPhoneNumber: {},
  streetAddress: {},
  country: {},
  postcode: {},
});
